import React, { useState } from 'react'
import * as PhosphorIcons from '@phosphor-icons/react'
import ContentSourceBadge from './ContentSourceBadge'
import { copyToClipboard, toast } from '../utils'
import ModalDeleteContent from './ModalDeleteContent'
import ModalRunAgainContent from './ModalRunAgainContent'

const ContentActions = ({
  project,
  content,
  listOfAgents,
  agents,
}) => {
  const [openDeleteContent, setOpenDeleteContent] = useState(false)
  const [openRunAgain, setOpenRunAgain] = useState(false)

  const deleteContent = async () => {
    const response = await fetch(`/projects/${project.id}/contents/${content.id}/`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
      }
    })
    if (response.ok) {
      toast({message: 'Content deleted successfully', type: 'success', duration: 3000, gravity: 'top', position: 'right', close: true})
      Turbo.visit(`/projects/${project.id}`)
    } else {
      toast({message: 'Failed to delete content', type: 'error', duration: 3000, gravity: 'top', position: 'right', close: true})
    }
  }

  const handleCopyToClipboard = () => {
    copyToClipboard(content.body)
    toast({message: 'Content copied to clipboard', type: 'success', duration: 3000, gravity: 'top', position: 'right', close: true})
  }

  const handleAgentRun = async (agent) => {
    const response = await fetch(`/projects/${project.id}/contents/${content.id}/redo`, {
      method: 'POST',
      body: JSON.stringify({ agent: agent.id }),
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
      }
    })
    if (response.ok) {
      toast({message: 'Agent run successfully', type: 'success', duration: 3000, gravity: 'top', position: 'right', close: true})
    } else {
      toast({message: 'Agent run failed', type: 'error', duration: 3000, gravity: 'top', position: 'right', close: true})
    }
  }


  const handleRunAgain = async () => {
    const response = await fetch(`/projects/${project.id}/contents/${content.id}/redo_all`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
      }
    })
    if (response.ok) {
      toast({message: 'Content run again successfully', type: 'success', duration: 3000, gravity: 'top', position: 'right', close: true})
    } else {
      toast({message: 'Content run again failed', type: 'error', duration: 3000, gravity: 'top', position: 'right', close: true})
    }
  }

  const filteredAgents = listOfAgents.filter(agent =>
    agents?.some(projAgent => projAgent.name === agent.id),
  )

  return (
    <div className="flex gap-3 items-center justify-end p-2">
      <ModalDeleteContent
        open={openDeleteContent}
        onClose={() => setOpenDeleteContent(false)}
        onDelete={deleteContent}
        content={content}
      />
      <ModalRunAgainContent
        open={openRunAgain}
        onClose={() => setOpenRunAgain(false)}
        onRunAgain={handleRunAgain}
        content={content}
        filteredAgents={filteredAgents}
      />
      <div className="flex-none text-base-content/70">
        <ContentSourceBadge source={content.source}/>
      </div>

      <div className="flex gap-2 items-center flex-wrap">
        <button
          onClick={() => setOpenDeleteContent(true)}
          className="btn btn-xs btn-error hover:brightness-110 transition-all btn-outline"
        >
          <div className="flex gap-2 items-center whitespace-nowrap">
            <span className="text-sm font-medium">Remove</span>
            <PhosphorIcons.Trash weight="bold" className="h-4 w-4"/>
          </div>
        </button>

        <div className={`dropdown ${agents.length === 0 ? 'pointer-events-none opacity-50' : ''}`}>
          <label tabIndex={0}
                 className={`btn btn-xs hover:brightness-110 transition-all btn-outline ${agents.length === 0 ? 'btn-disabled' : ''}`}>
            <div className="flex gap-2 items-center whitespace-nowrap">
              <span className="text-sm font-medium">Run Agent</span>
              <PhosphorIcons.Play weight="bold" className="h-4 w-4"/>
            </div>
          </label>
          <ul tabIndex={0}
              className="dropdown-content z-[50] menu p-1 shadow-lg bg-blue-50 rounded-lg w-80 max-h-[60vh] overflow-y-auto border border-base-300 mt-1 block">
            {filteredAgents.map(agent => (
              <li key={agent?.id}>
                <a
                  onClick={() => handleAgentRun(agent)}
                  className="hover:bg-base-300 active:bg-base-300 transition-colors p-2"
                >
                  <div className="flex items-center gap-2">
                    <div className={`p-1 rounded-lg ${agent?.bg_class}`}>
                      {PhosphorIcons[agent?.icon] ?
                        React.createElement(PhosphorIcons[agent?.icon], {
                          size: 16,
                          className: agent?.color_class,
                        })
                        :
                        <PhosphorIcons.Tag size={16}
                                           className={agent.color_class}/>
                      }
                    </div>
                    <span className="font-medium text-xs truncate">{agent.label}</span>
                  </div>
                </a>
              </li>
            ))}
          </ul>
        </div>

        <button
          onClick={setOpenRunAgain}
          className="btn btn-xs hover:brightness-110 transition-all btn-outline"
        >
          <div className="flex gap-2 items-center whitespace-nowrap">
            <span className="text-sm font-medium">Run Again</span>
            <PhosphorIcons.ArrowClockwise weight="bold" className="h-4 w-4"/>
          </div>
        </button>

        <div className="flex items-center">
          <button
            onClick={handleCopyToClipboard}
            className="btn btn-xs hover:brightness-110 btn-outline tooltip tooltip-left transition-all"
            data-tip="Copy result to clipboard"
          >
            <PhosphorIcons.Clipboard weight="bold" className="h-4 w-4"/>
          </button>
        </div>
      </div>
    </div>
  )
}

export default ContentActions